"use client";

import { type ReactElement, Suspense } from "react";
import { NotFoundContent } from "../NotFound/NotFound.tsx";
import { usePageData } from "../../../hooks/usePageData.ts";
import { useScrollToUrlHash } from "../../../hooks/useScrollToUrlHash.ts";
import { AppLayout } from "../../layout/AppLayout/AppLayout.tsx";
import { ComponentRenderer } from "../../utils/ComponentMapping/ComponentRenderer.tsx";
import { Helmet } from "react-helmet-async";
import { Loader } from "../../utils/Loader/Loader.tsx";

export function StandardPageProviders(): ReactElement {
  const {
    pageData: { componentContent, metaData },
    loading,
    notFound,
  } = usePageData();

  useScrollToUrlHash(!loading && !notFound && componentContent !== null);

  if (loading) {
    return <Loader fullBlock={true} text="Loading page content..." />;
  }

  // Render the page content only - navigation and footer are handled by AppLayout
  return (
    <Suspense>
      <AppLayout>
        {notFound || !componentContent ? (
          <NotFoundContent />
        ) : (
          <>
            <Helmet>
              <title>{metaData.title}</title>
              <meta name="description" content={metaData.description} />
              <meta property="og:title" content={metaData.title} />
              <meta property="og:image" content={metaData.image} />
            </Helmet>
            {componentContent.content && (
              <ComponentRenderer {...componentContent} />
            )}
          </>
        )}
      </AppLayout>
    </Suspense>
  );
}
